import PropTypes from 'prop-types';
import React, { Component } from 'react';

class ErrorBoundary extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
    };

    state = {
        error: null,
    };

    componentDidCatch (error, info) {
        /* eslint-disable no-console */
        console.error(error, info);
        /* eslint-enable no-console */
        this.setState({ error });
    }

    render () {
        const { error } = this.state;
        const { children, ErrorPage } = this.props;

        if (error) {
            return <ErrorPage />;
        }

        return children;
    }
}

ErrorBoundary.propTypes = {
    /** The component to render if an error occured */
    ErrorPage: PropTypes.func.isRequired,
};

export { ErrorBoundary };
